import {
  ハンディ棚卸情報型,
  棚卸作成依頼型,
  棚卸保存依頼型,
  棚卸再計算依頼型,
  棚卸取得依頼型,
  棚卸情報型,
  棚卸確定依頼型,
  棚卸絞込み依頼型,
  棚卸部署型,
  棚卸部署概要型,
  棚卸部署確定取消候補型,
} from '@/type/stocktaking/types';
import {棚卸表出力条件型} from '@/type/stocktaking/report';
import {StocktakingApi} from '@/infrastructure/api/stocktaking/stocktakingApi';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';

export class StandardStocktakingApi implements StocktakingApi {

  async 棚卸部署一覧を取得する(): Promise<棚卸部署型[]> {
    return api.棚卸部署一覧を取得する();
  }

  async 棚卸部署概要を取得する(棚卸部署コード: string): Promise<棚卸部署概要型> {
    return api.棚卸部署概要を取得する(棚卸部署コード);
  }

  async HT棚卸情報を取得する(棚卸番号: number): Promise<ハンディ棚卸情報型> {
    return api.HT棚卸情報を取得する(棚卸番号);
  }

  async 棚卸を取得する(棚卸取得依頼: 棚卸取得依頼型): Promise<棚卸情報型> {
    return api.棚卸を取得する(棚卸取得依頼);
  }

  async 棚卸を絞り込む(棚卸絞込み依頼: 棚卸絞込み依頼型): Promise<棚卸情報型> {
    return api.棚卸を絞り込む(棚卸絞込み依頼);
  }

  async 棚卸を作成する(棚卸作成依頼: 棚卸作成依頼型): Promise<棚卸情報型> {
    return api.棚卸を作成する(棚卸作成依頼);
  }

  async 棚卸を保存する(棚卸保存依頼: 棚卸保存依頼型): Promise<void> {
    return api.棚卸を保存する(棚卸保存依頼);
  }

  async 棚卸を確定する(棚卸番号: number, 棚卸確定依頼: 棚卸確定依頼型): Promise<void> {
    return api.棚卸を確定する(棚卸番号, 棚卸確定依頼);
  }

  async 棚卸を取り消す(棚卸番号: number): Promise<void> {
    return api.棚卸を取り消す(棚卸番号);
  }

  async HT棚卸情報を取り込む(棚卸番号: number): Promise<void> {
    return api.HT棚卸情報を取り込む(棚卸番号);
  }

  async 棚卸を再計算する(棚卸番号: number, 棚卸再計算依頼: 棚卸再計算依頼型): Promise<void> {
    return api.棚卸を再計算する(棚卸番号, 棚卸再計算依頼);
  }

  async 棚卸一覧表を出力する(filename: string, 棚卸一覧出力依頼: {}): Promise<void> {
    return download.棚卸一覧表を出力する(filename, 棚卸一覧出力依頼);
  }

  async 棚卸表帳票を出力する(filename: string, 棚卸表出力条件: 棚卸表出力条件型): Promise<void> {
    return download.棚卸表帳票を出力する(filename, 棚卸表出力条件);
  }

  async 棚卸部署確定取消候補を取得する(棚卸部署コード: string): Promise<棚卸部署確定取消候補型> {
    return api.棚卸部署確定取消候補を取得する(棚卸部署コード);
  }

  async 棚卸確定取消する(棚卸番号: number): Promise<void> {
    return api.棚卸確定取消する(棚卸番号);
  }
}
